module.exports = __webpack_public_path__ + "img/bg.11a3d183.png";